<template>
  <div class="waterway-or-intermodal-transportation" v-loading='importLoading'>
    <div style="margin-bottom: 10px; display: flex; align-items: center;">
      <el-button @click="onClickBack" icon="el-icon-arrow-left" size="small" style="margin-right: 10px;"></el-button>
      <div class="mr20">
        <span>委托商：</span>
        <el-input v-model="searchParams.consignor" placeholder="请输入委托商" style="width: 150px;" size="small"></el-input>
      </div>
      <div class="mr20">
        <span>运输方式：</span>
        <el-select v-model="searchParams.transportType" style="width: 150px;" size="small">
          <!-- <el-option v-for="item in transportTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
          <el-option label="全部" value=""></el-option>
          <el-option label="水路" :value="1"></el-option>
          <el-option label="水陆联运" :value="2"></el-option>
        </el-select>
      </div>
      <div class="mr20">
        <span>品牌：</span>
        <el-input v-model="searchParams.brand" placeholder="请输入品牌" style="width: 150px;" size="small"></el-input>
      </div>
      <el-button @click="getData" type="primary" size="small" class='searchBtn'>查询</el-button>
      <el-button @click="onClickReset" size="small">重置</el-button>
      <!-- <el-button @click="onClickRefresh" type="primary" size="small">刷新</el-button> -->
      <el-button @click="onClickAdd" type="primary" size="small">新增</el-button>
    </div>
    <div style="display: flex; justify-content: right;">
      <div style="display: flex; align-items: center;">
        <el-button @click="onClickDownloadTemplate" type="text">下载模版</el-button>
        <batch-import :uploadUrl='uploadUrl' @importSuccess='getData' @triggerLoading='importLoading = !importLoading' :params="{id: planId}"/>
        <el-button @click="onClickExportData" type="text">导出数据</el-button>
      </div>
    </div>
    <div class="table-wrap">
      <div class="table-inner">
        <el-table
          v-loading="tableLoad"
          :data='TableDatas'
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column label='委托商' prop='consignor' align='center' show-overflow-tooltip width="200px" />
          <el-table-column label='品牌' prop='brand' align='center' show-overflow-tooltip width="200px" />
          <el-table-column label='业务员1' prop='salespersonOne' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='业务员2' prop='salespersonTwo' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='属性' prop='attribute' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='标车系数' prop='standardCarCoefficient' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='流向' prop='flowDirection' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='运输方式' prop='transportType' align='center' show-overflow-tooltip width="100px">
            <template slot-scope="scope">
              {{ getOptionLabel('transportTypeOption', scope.row.transportType) }}
            </template>
          </el-table-column>
          <el-table-column label='起始地' prop='origin' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='目的地' prop='destination' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='装船港' prop='loadingPort' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='卸船港' prop='unloadingPort' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='江运航线' prop='route' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='船运单位' prop='water' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='数量（自然车）' align='center'>
            <el-table-column label='ms船' prop='naturalVehiclesMs' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='非ms船' prop='naturalVehiclesNoMs' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='合计' prop='naturalVehiclesTotal' align='center' show-overflow-tooltip width="100px" />
          </el-table-column>
          <el-table-column label='收入' prop='income' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='成本' prop='cost' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='毛利' prop='grossProfit' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='毛利占比' prop='grossProfitProportion' align='center' show-overflow-tooltip width="100px" />
          <el-table-column label='江运支出' align='center'>
            <el-table-column label='ms' prop='jiangYunMs' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='非ms' prop='jiangYunNoMs' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='小计' prop='jiangYunTotal' align='center' show-overflow-tooltip width="100px" />
          </el-table-column>
          <el-table-column label='公路收入' align='center'>
            <el-table-column label='集港费' prop='incomePortCollectionFee' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='配送费' prop='incomeDeliveryFee' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='小计' prop='incomeDeliveryFeeTotal' align='center' show-overflow-tooltip width="100px" />
          </el-table-column>
          <el-table-column label='公路支出' align='center'>
            <el-table-column label='集港费' prop='expenditurePortCollectionFee' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='配送费' prop='expenditureDeliveryFee' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='小计' prop='expenditureDeliveryFeeTotal' align='center' show-overflow-tooltip width="100px" />
          </el-table-column>
          <el-table-column label='自然车折标车量' align='center'>
            <el-table-column label='ms船' prop='foldedLabelMs' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='非ms船' prop='foldedLabelNoMs' align='center' show-overflow-tooltip width="100px" />
            <el-table-column label='小计' prop='foldedLabelTotal' align='center' show-overflow-tooltip width="100px" />
          </el-table-column>
          <el-table-column label='操作' width='210px' align='center' fixed="right">
            <template slot-scope='scope'>
              <el-button v-if="scope.row.consignor != '下水业务' && scope.row.consignor != '上水业务' && scope.row.consignor != '上下水业务合计' && scope.row.consignor != '上水量占比'" @click="onClickModify(scope.row)" type="warning" size="small">修改</el-button>
              <el-button v-if="scope.row.consignor != '下水业务' && scope.row.consignor != '上水业务' && scope.row.consignor != '上下水业务合计' && scope.row.consignor != '上水量占比'" @click="onClickDelete(scope.row.id)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增/修改弹窗 -->
    <el-dialog :title='editTitle' :visible.sync='editDialogVisible' width='800px' center @close='editDialogClose' :close-on-click-modal='false' top='10vh'>
      <div class='company'>
        <el-form :model='editData' label-width='100px' label-position="right" :inline="true">
          <el-row>
            <el-col :span="12">
              <el-form-item label="委托商：">
                <el-select v-model="editData.consignor" placeholder="请选择委托商" size="small" style="width: 260px;" filterable>
                  <el-option v-for="item in consignorOption" :key="item.id" :label="item.customerName" :value="item.customerName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌：">
                <el-select v-model="editData.brand" placeholder="请选择品牌" size="small" style="width: 260px;" filterable>
                  <el-option v-for="item in brandOption" :key="item.id" :label="item.brand" :value="item.brand"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务人员1：">
                <el-input v-model="editData.salespersonOne" placeholder="请输入业务人员1，格式：姓名，百分比" size="small" style="width: 260px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务人员2：">
                <el-input v-model="editData.salespersonTwo" placeholder="请输入业务人员2，格式：姓名，百分比" size="small" style="width: 260px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="属性：">
                <el-select v-model="editData.attribute" placeholder="请选择属性" size="small" style="width: 260px;">
                  <el-option v-for="item in attributeOption" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标车系数：">
                <el-input v-model="editData.standardCarCoefficient" placeholder="请输入标车系数" size="small" style="width: 260px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="流向：">
                <el-select v-model="editData.flowDirection" placeholder="请选择流向" size="small" style="width: 260px;">
                  <el-option v-for="item in flowDirectionOption" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运输方式：">
                <el-select v-model="editData.transportType" placeholder="请选择运输方式" size="small" style="width: 260px;">
                  <el-option v-for="item in transportTypeOption" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="起始地：">
                <el-input v-model="editData.origin" placeholder="请输入起始地" size="small" style="width: 260px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="目的地：">
                <el-input v-model="editData.destination" placeholder="请输入目的地" size="small" style="width: 260px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="装船港：">
                <el-select v-model="editData.loadingPort" placeholder="请选择装船港" size="small" style="width: 260px;" filterable>
                  <el-option v-for="item in portOption" :key="item.id" :label="item.portName" :value="item.portName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="卸船港：">
                <el-select v-model="editData.unloadingPort" placeholder="请选择卸船港" size="small" style="width: 260px;" filterable>
                  <el-option v-for="item in portOption" :key="item.id" :label="item.portName" :value="item.portName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="江运航线：">
                <el-input v-model="editData.route" placeholder="请输入江运航线" size="small" style="width: 260px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="船运单位：">
                <!-- <el-input v-model="editData.water" placeholder="请输入船运单位" size="small" style="width: 260px;"></el-input> -->
                <el-select v-model="editData.water" placeholder="请选择船运单位" size="small" style="width: 260px;" filterable>
                  <el-option v-for="item in waterOption" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数量（自然车）-ms船：" label-width="170px">
                <el-input v-model="editData.naturalVehiclesMs" placeholder="请输入ms船数量" size="small" style="width: 190px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数量（自然车）-非ms船：" label-width="190px">
                <el-input v-model="editData.naturalVehiclesNoMs" placeholder="请输入非ms船数量" size="small" style="width: 170px;"></el-input>
              </el-form-item>
            </el-col>
            <!--  -->
            <el-col :span="12">
              <el-form-item label="非民生成本单价：" label-width="130px">
                <el-input v-model="editData.importCostNoMs" placeholder="请输入非民生成本单价" size="small" style="width: 230px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民生成本单价：" label-width="120px">
                <el-input v-model="editData.importCostMs" placeholder="请输入民生成本单价" size="small" style="width: 240px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民生收入单价：" label-width="120px">
                <el-input v-model="editData.importIncome" placeholder="请输入民生收入单价" size="small" style="width: 240px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class='btnContainer'>
          <el-button class='searchBtn' @click='onClickSure' size='small'>确定</el-button>
          <el-button class='resetBtn' @click='editDialogVisible = false' size='small'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import { getMapCustomer, getMapBrands, getMapPort, yearMonthPlanWaterwayAddAll, yearMonthPlanWaterwayAddList, yearMonthPlanWaterwayGetMapWater, yearMonthPlanWaterwayAddUpdateAll, yearMonthPlanWaterwayAddDeleteAll } from '@/service/vehiclelog';
  export default {
    components: { BatchImport },
    props: ['planId'],
    data() {
      return {
        searchParams: {
          consignor: '',
          transportType: '',
          brand: '',
        },
        uploadUrl: '/yearMonthPlanWaterway/all/import',
        importLoading: false,
        tableLoad: false,
        editTitle: '', // 新增 - 修改
        editDialogVisible: false,
        TableDatas: [],
        editData: {},
        consignorOption: [],
        brandOption: [],
        portOption: [],
        waterOption: [],
        attributeOption: [
          { label: '内贸', value: '内贸' },
          { label: '外贸', value: '外贸' },
        ],
        flowDirectionOption: [
          { label: '上水', value: '上水' },
          { label: '下水', value: '下水' },
        ],
        transportTypeOption: [
          { label: '水路', value: 1 },
          { label: '水陆联运', value: 2 },
        ],
      }
    },
    mounted() {
      this.getOption();
      this.getData();
    },
    methods: {
      onClickReset() {
        this.searchParams = {
          consignor: '',
          transportType: '',
          brand: '',
        };
      },
      onClickExportData() {
        window.exportExcelAll('get', '/yearMonthPlanWaterway/all/exportXls', {planId:this.planId, ...this.searchParams});
      },
      onClickBack() {
        this.$emit('setPageType', 0);
      },
      onClickDownloadTemplate() {
        window.exportExcelAll('get', '/yearMonthPlanWaterway/all/export', {});
      },
      async onClickDelete(id) {
        
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {status, message} = await yearMonthPlanWaterwayAddDeleteAll({ids: id});
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.getData();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      onClickModify(row) {
        this.editTitle = '修改'
        this.editData = row;
        this.editDialogVisible = true;
      },
      onClickRefresh() {
        this.getData();
      },
      getOptionLabel(key, value) {
        let label = '';
        this[key].forEach(option => {
          if (option.value == value) {
            label = option.label;
          }
        });
        return label;
      },
      async getData() {
        this.tableLoad = true;
        const {data} = await yearMonthPlanWaterwayAddList({planId: this.planId, ...this.searchParams});
        // console.log(data);
        if (data['上水量占比']) data['上水量占比'][0]['naturalVehiclesMs'] = data['上水量占比'][0]['vehiclesMs'];
        if (data['上水量占比']) data['上水量占比'][0]['naturalVehiclesNoMs'] = data['上水量占比'][0]['vehiclesNoMs'];
        if (data['上水量占比']) data['上水量占比'][0]['naturalVehiclesTotal'] = data['上水量占比'][0]['vehiclesTotal'];
        this.TableDatas = [];
        // this.TableDatas = [
        //   ...data['下水'],
        //   ...data['上水'],
        //   ...data['上下水业务合计'],
        //   ...data['上水量占比']
        // ];
        if (data['下水']) this.TableDatas = this.TableDatas.concat(data['下水']);
        if (data['上水']) this.TableDatas = this.TableDatas.concat(data['上水']);
        if (data['上下水业务合计']) this.TableDatas = this.TableDatas.concat(data['上下水业务合计']);
        if (data['上水量占比']) this.TableDatas = this.TableDatas.concat(data['上水量占比']);
        this.tableLoad = false;
      },
      onClickAdd() {
        this.editTitle = '新增';
        this.editData = {};
        this.editDialogVisible = true;
      },
      editDialogClose() {},
      async onClickSure() {
        let statusi, messagei;
        if (this.editTitle == '新增') {
          const {status, message} = await yearMonthPlanWaterwayAddAll({...this.editData, planId:this.planId});
          statusi = status;
          messagei = message;
        } else {
          const {status, message} = await yearMonthPlanWaterwayAddUpdateAll({...this.editData, planId:this.planId});
          statusi = status;
          messagei = message;
        }
        
        if (statusi !== 0) return this.$message.error(messagei);
        this.$message.success(messagei);
        this.editDialogVisible = false;
        this.getData();
      },
      async getOption() {
        const resConsignor = await getMapCustomer();
        const resBrand = await getMapBrands();
        const resPort = await getMapPort();
        const resMapWater = await yearMonthPlanWaterwayGetMapWater();
        this.consignorOption = resConsignor.data;
        // console.log(resPort.data);
        this.brandOption = resBrand.data;
        this.portOption = resPort.data
        this.waterOption = resMapWater.data;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .waterway-or-intermodal-transportation {
    height: 100%;
    display: flex;
    flex-direction: column;
    .table-wrap {
      flex: 1;
      overflow: auto;
      position: relative;
      .table-inner {
        width: 100%;
        position: absolute;
      }
    }
    .mr20 {
      margin-right: 20px;
    }
  }
</style>
